import React from 'react';
import { TabbedIncomeExpensePage } from './TabbedIncomeExpensePage';
import { FINANCIAL_REPORT_TABS } from './tabConfigs';

const ExportIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
    />
  </svg>
);

const FinancialReportsPage: React.FC = () => (
  <TabbedIncomeExpensePage
    pageTitle="Báo cáo tài chính"
    pageCode="IE_FINANCIAL_REPORTS"
    tabs={FINANCIAL_REPORT_TABS}
    actions={[{ label: 'Xuất báo cáo', variant: 'success', icon: <ExportIcon /> }]}
  />
);

export default FinancialReportsPage;
